import type { BadgeProps, BadgeVariant } from '@repo/foundations';
import { Badge } from '@repo/foundations';
import { memo } from 'react';

enum AiChatQuality {
	GOOD = 'good',
	ACCEPTABLE = 'acceptable',
	POOR = 'poor',
}

const BADGE_VARIANT: Record<AiChatQuality, BadgeVariant> = {
	[AiChatQuality.GOOD]: 'success',
	[AiChatQuality.ACCEPTABLE]: 'caution',
	[AiChatQuality.POOR]: 'warning',
};

export const AiQualityBadgeController = memo(
	({ score, ...props }: { score?: number } & BadgeProps) => {
		if (!score) {
			return null;
		}

		let quality = AiChatQuality.POOR;

		if (score >= 7) {
			quality = AiChatQuality.GOOD;
		} else if (score >= 4) {
			quality = AiChatQuality.ACCEPTABLE;
		}

		return (
			<Badge variant={BADGE_VARIANT[quality]} {...props}>
				{quality}
			</Badge>
		);
	}
);
